export default __webpack_public_path__ + "static/media/iOS Preview.11a86e29.png";